import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoaderSpinner from "../../common/Loader";
import {
  getAllCountries,
  getDimensionUnitList,
  getWeightUnitList,
} from "../../../store/actions";
import { allowedExtensions, barCode, CMSEnum, featureSubmodule, InchEnum, ItemTypeList, SUBF_ADHOCBARCODEGENERATION, WEIGHT_UNIT_GM, WEIGHT_UNIT_KG, WEIGHT_UNIT_LB } from "../../../constant";
import {
  createInventoryProduct,
  deleteWarehouseLocation,
  getAllConsignmentType,
  getProductById,
  resetProductDetails,
  updateAttachmentsByProductsId,
  updateInventoryProduct,
  uploadProductMedia,
} from "../../../store/actions/inventory.action";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { appendFilesToUploadData, checkPermission, handleDocsUpload } from "../../../config/utils";
import ProductImageSlider from "./ProductImageSlider";
import AlertDialogModal from "../../common/AlertDialog";
import { Accordion } from "react-bootstrap";
import WarehouseDetails from "./WarehouseDetails";
import MarketplaceDraftsSection from "./MarketplaceDraftsSection";
import { InventoryProductBackDetails } from "../../../store/actions/employee";
import _ from "lodash";
import BarCodeGeneratePopup from "./BarCodePopup";
import { getLocalStorageItem, removeLocalStorageItem } from "../../../services/StorageService";
import BarcodeBtn from "./BarcodeBtn";
import BarcodeScannerComponent from "../../common/BarCodeScanner";
import PropTypes from "prop-types";

const ProductInventory = (props) => {
  const { id } = useParams();
  const location = useLocation();
  let stateObj = JSON.parse(getLocalStorageItem('productObj'));
  const [isEditable, setIsEditable] = useState(location?.state?.isEdit || stateObj);
  const [showBarCodeModal, setShowBarCodeModal] = useState(false);
  const [barCodeRecord, setBarCodeRecord] = useState({});
  const userDetails = useSelector((state) => state.auth.user);
  const countries = useSelector((state) => state.shipment.countries);
  const { productDetails, productDetailsStatus } = useSelector(
    (state) => state.InventoryManagement
  );
  const { warehouseList } = useSelector((state) => state.InventoryManagement);
  const [loader, setLoader] = useState(false);
  const [deletedWareHouses, setDeletedWareHouses] = useState([]);
  const [image, setImage] = useState([]);
  const [isFormEdited, setIsFormEdited] = useState(false);
  const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
  const [attachmentFile, setAttachmentFile] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setErrors] = useState({});
  const [productFormCopy, setProductFormCopy] = useState({});
  const [showScanner, setShowScanner] = useState(false);
  const [selectedScannedData, setSelectedScannedData] = useState({});
  const { consignmentTypes } = useSelector(
    (state) => state.InventoryManagement
  );
  const { dimensionUnitList, weightUnitList } = useSelector(
    (state) => state.shipment
  );

  useEffect(() => {
    return () => {
      dispatch(resetProductDetails());
      removeLocalStorageItem('stateObj');
    };
  }, []);

  useEffect(() => {
    if (!dimensionUnitList.length) {
      dispatch(getDimensionUnitList());
    }

    if (!weightUnitList.length) {
      dispatch(getWeightUnitList());
    }
  }, [dimensionUnitList, weightUnitList]);

  const productObj = {
    isSuperAdmin: true,
    createdBy: 0,
    id: 0,
    productName: "",
    externalProductId: "",
    productDescription: "",
    productSku: "",
    quantity: "",
    productUpc: "",
    warehouseLocation: "",
    hsn: "",
    uom: "",
    length: "",
    width: "",
    height: "",
    weight: "",
    weightUnit: 1,
    DimensionUnit: 1,
    ounces: "",
    unit: 1,
    ean: "",
    isbn: "",
    itemExpiryRaw: "",
    condition: "",
    itemExpiryDate: new Date(moment().add(1, "y")),
    inventoryProductCondition_Id: 1,
    mpn: "",
    sellingPrice: "",
    costPrice: "",
    isActive: 0,
    wareHouseDetails: [
      {
        warehouseId: 0,
        comments: "",
        itemExpiryDate: "",
        countryOfOrigin: "",
        sellerLocation: "",
        supplierCode: "",
        quantity: 0,
        areaId: 0,
        rowId: 0,
        bayId: 0,
        levelId: 0,
        positionId: 0,
        storageId: ''
      },
    ],
    option1: "",
    name1: "",
    option2: "",
    name2: "",
    option3: "",
    name3: new Date(),
    consignmentTypeId: 3,
  };
  const [productForm, setProductForm] = useState({});

  useEffect(() => {
    if (Number(id)) {
      getProductDetailsById(id);
    } else {
      setProductForm({ ...productObj });
    }
  }, [id]);

  useEffect(() => {
    if (!consignmentTypes.length) {
      dispatch(getAllConsignmentType());
    }
  }, [consignmentTypes]);

  useEffect(() => {
    if (Number(id) > 0) {
      setProductFormCopy(JSON.parse(JSON.stringify(productDetails)));
      let elem = { ...productDetails };
      if (elem?.wareHouseDetails && !elem.wareHouseDetails.length) {
        elem.wareHouseDetails = [...productObj.wareHouseDetails];
      }
      if (elem?.attachments) {
        setAttachmentFile([...(productDetails?.attachments || [])]);
      }
      setProductForm(elem);
    }
  }, [productDetails]);

  useEffect(() => {
    if (productDetailsStatus === "pending") {
      setLoader(true);
    }
    setLoader(false);
  }, [productDetailsStatus]);

  const getProductDetailsById = (productId) => {
    dispatch(getProductById(productId));
  };

  useEffect(() => {
    if (!countries.length) {
      dispatch(getAllCountries());
    }
  }, [userDetails?.Value?.employeeId]);

  // Scroll the user to the Marketplace Drafts section after a successful create
  // (handleCreateProduct navigates here with focusMarketplaces: true). Runs once
  // when the product details land so the target element actually exists in the DOM.
  useEffect(() => {
    if (location?.state?.focusMarketplaces && Number(id) > 0 && productForm?.id) {
      // Defer one tick so the conditional render of the section has flushed.
      const t = setTimeout(() => {
        const el = document.getElementById("marketplace-drafts-section");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [location?.state?.focusMarketplaces, id, productForm?.id]);

  const handleOpenScan = (e, inputKey) => {
    e.preventDefault();
    setSelectedScannedData({ formKey: inputKey });
    setShowScanner(!showScanner);
  }

  const handleScanSuccess = (scannedValue) => {
    setProductForm({
      ...productForm,
      [selectedScannedData.formKey]: scannedValue
    });
    setShowScanner(false);
  }

  const handleFormValidation = () => {
    let error = {};
    let isFormValid = true;
    if (!productForm.productName) {
      error.productName = "This is required.";
      isFormValid = false;
    }
    if (!productForm.productDescription) {
      error.productDescription = "This is required.";
      isFormValid = false;
    }
    if (!productForm.productSku) {
      error.productSku = "This is required.";
      isFormValid = false;
    }
    if (Number(id) === 0 && !image.length) {
      error.image = "Select product image.";
      isFormValid = false;
    }

    setErrors(error);
    if (!isFormValid) {
      toast.error("Validation failed");
      return;
    }
    return isFormValid;
  };

  const handleInputBlur = (e) => {
    const { name, value } = e.target;
    setProductForm({ ...productForm, [name]: value.trim() });
  };

  const handleFormValue = (e) => {
    const { name, value } = e.target;
    let productFormClone = _.cloneDeep(productForm);

    if (name === 'weightUnit') {
      if (Number(value) === WEIGHT_UNIT_KG || Number(value) === WEIGHT_UNIT_GM) {
        productFormClone.DimensionUnit = CMSEnum;
      } else {
        productFormClone.DimensionUnit = InchEnum;
      }
    } else if (name === 'DimensionUnit') {
      if (Number(value) === InchEnum) {
        productFormClone.weightUnit = WEIGHT_UNIT_LB;
      } else {
        productFormClone.weightUnit = WEIGHT_UNIT_KG;

      }
    }
    productFormClone[name] = value;
    setProductForm(productFormClone);
    setErrors({ ...error, [name]: "" });
    setIsFormEdited(true);
  };

  const handleDateChange = (date, field) => {
    setProductForm({ ...productForm, [field]: date });
  };

  const uploadImages = async (id, type, redirectTarget = "/inventory") => {
    let uploadData = new FormData();
    uploadData.append("id", id);
    uploadData = appendFilesToUploadData(uploadData, image, "images");
    let uploadMediaRes = await Promise.resolve(
      dispatch(uploadProductMedia(uploadData))
    );
    if (uploadMediaRes?.data?.Status === 200) {
      toast.success(`Product ${type} successfully`);
      // For create, redirectTarget points at the new product's edit page so the
      // Marketplace Drafts section becomes available as a natural Step 2; for
      // update we keep the legacy "back to inventory list" behavior.
      navigate(redirectTarget, redirectTarget !== "/inventory" ? { state: { isEdit: true, focusMarketplaces: true } } : undefined);
      setLoader(false);
    }
  };

  const handleUpdateProduct = () => {
    if (image.length > 0) {
      uploadImages(id, "updated");
    } else {
      toast.success(`Product Updated successfully`);
      navigate("/inventory");
      setLoader(false);
    }
  };

  const handleImagesLogic = (productFormObj) => {
    let filterEditedImages = productFormObj.images.filter(
      (item) => item.isEditable
    );
    if (filterEditedImages.length) {
      productFormObj.imageActions = filterEditedImages;
    }
    delete productFormObj.images;
    return productFormObj;
  };

  const handleCreateProduct = async (productFormObj) => {
    let createProductRes = await Promise.resolve(
      dispatch(createInventoryProduct(productFormObj))
    );
    if (createProductRes?.data?.Status === 200) {
      const newId = createProductRes.data.Entity;
      handleUploadAttachments(newId);
      // After create, route to the new product's edit page (not back to the list)
      // so the user can fill marketplace listing drafts as a natural Step 2.
      uploadImages(newId, "has been added", `/inventory/${newId}`);
    } else {
      toast.error(createProductRes.data.Message.AppStatusDescription);
      setLoader(false);
    }
  };

  const handleDeleteWareHouse = () => {
    if (deletedWareHouses.length) {
      let data = {
        inventoryIds: [...deletedWareHouses],
        productId: Number(id),
        modifiedBy: 0
      }
      dispatch(deleteWarehouseLocation(data));
    }
  };

  const handleQuantityValidation = () => {
    let productFormObj = JSON.parse(JSON.stringify(productForm));
    let findQuantity = productFormObj.wareHouseDetails.find(
      warehouse =>
        Number(warehouse.quantity) > 0 &&
        (!warehouse.comments || warehouse.comments.trim() === '')
    );
    if (findQuantity) {
      toast.error("Please enter notes for warehouse where quantity is greater than 0");
      return false;
    }
    return true;
  };

  const handleSaveProduct = async () => {
    if (handleFormValidation() && handleQuantityValidation()) {
      let productFormObj = JSON.parse(JSON.stringify(productForm));
      productFormObj.quantity = Number(productFormObj.quantity);
      productFormObj.costPrice = Number(productFormObj.costPrice);
      productFormObj.sellingPrice = Number(productFormObj.sellingPrice);
      productFormObj.inventoryProductCondition_Id = Number(
        productFormObj.inventoryProductCondition_Id
      );
      productFormObj.unit = Number(productFormObj.unit);
      productFormObj.length = Number(productFormObj.length);
      productFormObj.width = Number(productFormObj.width);
      productFormObj.height = Number(productFormObj.height);
      productFormObj.consignmentTypeId = productFormObj.consignmentTypeId
        ? productFormObj.consignmentTypeId
        : 3;
      productFormObj.attachmentActions = attachmentFile.filter((item) => item.id && item.isDeleted);
      productFormObj.weight = Number(productFormObj.weight);
      productFormObj.ounces = Number(productFormObj.ounces);
      productFormObj.wareHouseDetails.map(function (item) {
        delete item.address;
        delete item.bayList;
        delete item.areaList;
        delete item.levelList;
        delete item.positionList;
        delete item.rowList;
        return item;
      });

      setIsFormEdited(false);
      setLoader(true);
      dispatch(InventoryProductBackDetails());
      if (Number(id)) {
        let payloadData = handleImagesLogic(productFormObj);
        let saveResponse = await Promise.resolve(
          dispatch(updateInventoryProduct(payloadData))
        );
        if (saveResponse?.data?.Status === 200) {
          handleUploadAttachments(id);
          handleUpdateProduct();
          handleDeleteWareHouse();
        } else {
          toast.error(saveResponse.data.Message.AppStatusDescription);
        }
        setLoader(false);
      } else {
        handleCreateProduct(productFormObj);
      }
    }
  };

  const handleEditable = () => {
    setIsEditable(true);
  };

  const handleImageUpload = (e) => {
    let files = [...e.target.files];
    try {
      if (files.length > 0 && files.length <= 5) {
        let filterFiles = files.filter((file, index) => {
          const extension = file.name.split(".").slice(-1).pop();
          const fileSize = Math.round(file.size / 1024);
          if (
            !allowedExtensions.includes(
              extension ? extension.toLowerCase() : ""
            )
          ) {
            files.splice(index, 1);
            toast.error("Unsupported File format", 1000);
            return false;
          } else if (fileSize > 15000) {
            files.splice(index, 1);
            e.target.value = "";
            toast.info("Each picture size should be less than 1MB", 1000);
            return false;
          }
          return file;
        });

        setErrors({ ...error, image: "" });
        setImage([...image, ...filterFiles]);
      } else if (files.length > 5) {
        toast.info("Only 5 images can be upload at one time", 1000);
        e.target.value = "";
      } else {
        e.target.value = "";
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteImage = (index) => {
    let images = [...image];
    images.splice(index, 1);
    setImage(images);
  };

  const handleDeleteDoc = (item, index) => {
    let files = [...attachmentFile];
    if (item.id) {
      files[index].isDeleted = true;
    } else {
      files.splice(index, 1);
    }
    setAttachmentFile(files);
  };

  const handleBack = (type = false) => {
    if (isFormEdited && !type) {
      setShowUnsavedDialog(true);
      return;
    }
    navigate("/inventory");
  };

  const removeWarehouse = (index) => {
    let data = { ...productForm };
    if (Number(id) > 0) {
      let deletedWareHouseList = [...deletedWareHouses];
      deletedWareHouseList.push(data.wareHouseDetails[index].id)
      setDeletedWareHouses(deletedWareHouseList);
    }
    data.wareHouseDetails.splice(index, 1);
    setProductForm(data);
  };

  const addWarehouse = () => {
    let data = _.cloneDeep(productForm);
    data.wareHouseDetails.push({ wareHouseName: "", id: 0, quantity: 1 });
    setProductForm(data);
  };

  useEffect(() => {
    productForm?.wareHouseDetails?.forEach((warehouse, index) => {
      if (warehouse?.warehouseId) {
        let warehouseListData = warehouseList?.filter(
          (item) => item.id === Number(warehouse?.warehouseId)
        );
        let updatedWareHouseDetails = [...(productForm?.wareHouseDetails || [])];
        if (warehouseListData?.length > 0) {
          updatedWareHouseDetails[index].address = warehouseListData[0];
        }
        setProductForm((prevState) => ({
          ...prevState,
          wareHouseDetails: updatedWareHouseDetails,
        }));
      }
    });
  }, [warehouseList]);

  const handleWarehouse = (e, index, isNumber = false) => {
    const { value, name } = e.target;
    let data = _.cloneDeep(productForm);
    data.wareHouseDetails[index][name] = isNumber ? Number(value) : value;
    if (name === "warehouseId") {
      let warehouseListData = warehouseList?.filter(
        (item) => item.id === Number(value)
      );
      data.wareHouseDetails[index].address = warehouseListData[0];
      data.wareHouseDetails[index].areaId = 0;
      data.wareHouseDetails[index].rowId = 0;
      data.wareHouseDetails[index].bayId = 0;
      data.wareHouseDetails[index].levelId = 0;
      data.wareHouseDetails[index].positionId = 0;
    }
    if (name === 'itemExpiryDate') {
      let dateSelected = moment(value).utc(true).format();
      data.wareHouseDetails[index][name] = dateSelected;
    }
    setProductForm(data);
  };

  const updateWareHouseDetails = (index, name, list) => {
    setProductForm((prevForm) => {
      // Create a new copy of the warehouse details array
      let updatedWareHouseDetails = [...prevForm.wareHouseDetails];

      // Create a new copy of the specific warehouse object
      let updatedWarehouse = { ...updatedWareHouseDetails[index] };

      // Update the specific property
      updatedWarehouse[name] = list;

      // Replace the warehouse in the array
      updatedWareHouseDetails[index] = updatedWarehouse;

      // Return the new product form state
      return {
        ...prevForm,
        wareHouseDetails: updatedWareHouseDetails,
      };
    });
  };

  const handleUploadAttachments = async (id) => {
    let findUploadedFiles = attachmentFile.filter((attachment) => !attachment.id);
    if (findUploadedFiles.length) {
      let uploadData = new FormData();
      uploadData.append("id", id);
      uploadData = appendFilesToUploadData(uploadData, findUploadedFiles, "Attachments");
      let saveResponse = await Promise.resolve(dispatch(updateAttachmentsByProductsId(uploadData)));
      if (saveResponse.data && saveResponse.data.Status !== 200) {
        console.error(saveResponse.data.Entity);
      }
    }
  };

  const handleBarCodeClick = (item, marketPlace = '') => {
    let itemClone = _.cloneDeep(item);
    itemClone.productSku = itemClone[marketPlace];
    setBarCodeRecord(itemClone);
    setShowBarCodeModal(true);
  }

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          {id === "0" && "Create Product"}{" "}
          {id !== "0" && isEditable && "Edit Product"}{" "}
          {id !== "0" && !isEditable && "View Product"}
          <div className="top_right_button_container">
            <button
              className="btn cus-seconday-bg-btn top-btn"
              disabled={loader || !isEditable}
              onClick={handleSaveProduct}
            >
              {Number(id) ? "Save" : "Create"}
            </button>
            {Number(id) > 0 && (
              <button
                className="btn cus-seconday-bg-btn top-btn"
                disabled={loader || isEditable}
                onClick={handleEditable}
              >
                Edit
              </button>
            )}
            <button
              className="btn cus-primary-transparent-btn"
              onClick={() => handleBack(false)}
            >
              Back
            </button>
          </div>
        </div>
        {loader && <LoaderSpinner />}

        <div className="cus-page-content-sec">
          <div className="incomingAccordion accordion">
            <div className="row fontFix">
              <div className={Number(id) > 0 ? "col-lg-9 col-sm-12" : "col-12"}>
                <Accordion
                  defaultActiveKey={["0", "1", "2", "3", "4", "5", "6"]}
                  alwaysOpen={true}
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      Details{" "}
                      <i className="fa fa-chevron-down" aria-hidden="true"></i>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="row addressForm">
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3 zIndex2">
                          <div>
                            Product SKU{" "}
                            <span className="smallTxt">
                              (Stock Keeping Unit)
                            </span>{" "}
                            <span className="error">*</span>
                          </div>
                          <div className="generateSkuInputWrapper">
                            <div className='flexCenter'>
                              <input
                                className={`form-control productSku ${error.productSku && "errorField"
                                  }`}
                                type={"text"}
                                name="productSku"
                                value={productForm.productSku}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                              />
                              <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="productSku" />
                            </div>

                            <div className="generateBar">
                              {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && productForm.productSku && (
                                <button className="btn generateBar pr-0 pt-0 pb-0" onClick={() => handleBarCodeClick(productForm, 'productSku')}>Generate Barcode</button>
                              )}
                            </div>

                          </div>
                          <div className="error">{error.productSku}</div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            Product Name <span className="error">*</span>
                          </div>
                          <input
                            className={`form-control productName ${error.productName && "errorField"
                              }`}
                            type={"text"}
                            name="productName"
                            value={productForm.productName}
                            disabled={!isEditable}
                            onChange={handleFormValue}
                            onBlur={handleInputBlur}
                          />
                          <div className="error">{error.productName}</div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            Product Description <span className="error">*</span>
                          </div>
                          <input
                            className={`form-control productDescription ${error.productDescription && "errorField"
                              }`}
                            type={"text"}
                            name="productDescription"
                            value={productForm.productDescription}
                            onChange={handleFormValue}
                            onBlur={handleInputBlur}
                            disabled={!isEditable}
                          />
                          <div className="error">
                            {error.productDescription}
                          </div>
                        </div>
                      </div>
                      <div className="row addressForm">
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div className="input-label-txt">Item Type</div>
                          <div className="generateSkuInputWrapper">
                            <div className='flexCenter'>
                              <select
                                disabled={!isEditable}
                                onChange={handleFormValue}
                                value={productForm?.itemType}
                                name={"itemType"}
                                className="form-control noMarginBtm"
                              >
                                <option selected value={0}>Select</option>
                                {ItemTypeList.map((item, index) => (
                                  <option key={item.value} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        {Number(productForm?.itemType) === 1 && (
                          <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                            <div className="input-label-txt">Item per Bundle</div>
                            <div className="generateSkuInputWrapper">
                              <div className='flexCenter'>
                                <input
                                  className={`form-control itemPerBundle`}
                                  type={"number"}
                                  name="itemPerBundle"
                                  value={productForm?.itemPerBundle}
                                  onChange={handleFormValue}
                                  onBlur={handleInputBlur}
                                  min={0}
                                  disabled={!isEditable}
                                  onKeyDown={(evt) =>
                                    ["e", "E", "+", "-"].includes(evt.key) &&
                                    evt.preventDefault()
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3 generateSkuInputWrapper">
                          <div>Product Id</div>
                          <input
                            className={`form-control externalProductId`}
                            type={"text"}
                            name="externalProductId"
                            value={productForm.externalProductId}
                            onChange={handleFormValue}
                            onBlur={handleInputBlur}
                            disabled={!isEditable}
                          />
                          <div className="generateBar">
                            {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && productForm.externalProductId && (
                              <button className="btn generateBar pr-0 pt-0 pb-0" onClick={() => handleBarCodeClick(productForm, 'externalProductId')}>Generate Barcode</button>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            Product Type <span className="error">*</span>
                          </div>
                          <select
                            value={productForm.consignmentTypeId}
                            className={`form-control consignmentTypeId`}
                            onChange={handleFormValue}
                            name="consignmentTypeId"
                            disabled={!isEditable}
                          >
                            {consignmentTypes?.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            Upload Product Images{" "}
                            <span className="error">*</span>
                          </div>
                          <div className="fileUpload inventory">
                            <button
                              disabled={!isEditable}
                              type="button"
                              className="btn cus-seconday-bg-btn"
                            >
                              Upload images
                            </button>
                            <input
                              className="hiddenFileField"
                              onChange={handleImageUpload}
                              disabled={!isEditable}
                              accept="image/*"
                              type="file"
                              id="customFile"
                              multiple
                            />
                            <div className="error">{error.image}</div>
                          </div>
                          <div className="fileUpload inventory mobDevices mt-2">
                            <button
                              disabled={!isEditable}
                              type="button"
                              className="btn cus-seconday-bg-btn"
                            >
                              Use Camera
                            </button>
                            <input
                              className="hiddenFileField"
                              onChange={handleImageUpload}
                              disabled={!isEditable}
                              accept="image/*"
                              capture="environment"
                              type="file"
                              id="customFile"
                              multiple
                            />
                            <div className="error">{error.image}</div>
                          </div>
                          <div>
                            {image.length > 0 &&
                              image.map((item, index) => (
                                <div className="selectedFile mr-2" key={item?.id}>
                                  <div className="fileName">{item.name}</div>
                                  <button
                                    className="deleteImg"
                                    onClick={() => handleDeleteImage(index)}
                                  >
                                    <i
                                      className="fa fa-times"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              ))}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>Upload Attachments</div>
                          <div className="fileUpload inventory">
                            <button
                              disabled={!isEditable}
                              type="button"
                              className="btn cus-seconday-bg-btn"
                            >
                              Upload Documents
                            </button>
                            <input
                              className="hiddenFileField"
                              onChange={(e) => {
                                handleDocsUpload(e, toast, error, setErrors, setAttachmentFile, attachmentFile);
                              }}
                              disabled={!isEditable}
                              type="file"
                              id="customFile"
                              multiple
                            />
                          </div>
                          <div>
                            {attachmentFile.length > 0 &&
                              attachmentFile.map((item, index) => (
                                <>
                                  {!item.isDeleted && (
                                    <div className="selectedFile mr-2" key={item?.id}>
                                      <div className="fileName">
                                        {item.fileUrl ? (
                                          <a
                                            href={item.fileUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            {item.name}
                                          </a>
                                        ) : (
                                          <>{item.name}</>
                                        )}
                                      </div>
                                      <button
                                        className="deleteFile"
                                        onClick={() =>
                                          handleDeleteDoc(item, index)
                                        }
                                        disabled={!isEditable}
                                      >
                                        <i className="fa fa-times" aria-hidden="true"></i>
                                      </button>
                                    </div>
                                  )}
                                </>
                              ))}
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      Dimensions{" "}
                      <i className="fa fa-chevron-down" aria-hidden="true"></i>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="row mb-15 fontFix">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-2 col-md-4 col-sm-6 mobMb-10">
                              <div>Weight</div>
                              <input
                                className="form-control weight"
                                type="number"
                                maxLength={10}
                                min={0}
                                name="weight"
                                value={productForm.weight}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                              />
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-6 mobMb-10">
                              <div>Weight Unit</div>
                              <select
                                className="form-control"
                                onChange={handleFormValue}
                                name="weightUnit"
                                value={productForm.weightUnit}
                                disabled={!isEditable}
                              >
                                {weightUnitList.length > 0 &&
                                  weightUnitList.map((weight) => (
                                    <option key={weight.id} value={weight.id}>
                                      {weight.name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-6 mobMb-10">
                              <div>Length</div>
                              <input
                                className="form-control length"
                                type="number"
                                maxLength={10}
                                min={0}
                                name="length"
                                value={productForm.length}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                              />
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-6 mobMb-10">
                              <div>Width</div>
                              <input
                                className="form-control width"
                                type="number"
                                maxLength={10}
                                min={0}
                                name="width"
                                value={productForm.width}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                              />
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-6 mobMb-10">
                              <div>Height</div>
                              <input
                                className="form-control height"
                                type="number"
                                maxLength={10}
                                min={0}
                                name="height"
                                value={productForm.height}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                              />
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-6 mobMb-10">
                              <div>Dimension Unit</div>
                              <select
                                className="form-control DimensionUnit"
                                onChange={handleFormValue}
                                name="DimensionUnit"
                                value={productForm.DimensionUnit}
                                disabled={!isEditable}
                              >
                                {dimensionUnitList.length > 0 &&
                                  dimensionUnitList.map((dimension) => (
                                    <option
                                      key={dimension.id}
                                      value={dimension.id}
                                    >
                                      {dimension.name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row addressForm"></div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      Warehouse Location {" "}
                      <i className="fa fa-chevron-down" aria-hidden="true"></i>
                    </Accordion.Header>
                    <Accordion.Body>
                      {productForm?.wareHouseDetails &&
                        productForm?.wareHouseDetails.length > 0 &&
                        productForm?.wareHouseDetails.map((item, index) => (
                          <div key={item.id}>
                            <WarehouseDetails
                              item={item}
                              handleFormValue={handleFormValue}
                              isEditable={isEditable}
                              handleInputBlur={handleInputBlur}
                              addWarehouse={addWarehouse}
                              index={index}
                              removeWarehouse={removeWarehouse}
                              productForm={productForm}
                              setProductForm={setProductForm}
                              handleWarehouse={handleWarehouse}
                              updateWareHouseDetails={updateWareHouseDetails}
                              error={error}
                              userDetails={userDetails}
                            />
                          </div>
                        ))}
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      Technicals{" "}
                      <i className="fa fa-chevron-down" aria-hidden="true"></i>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="row addressForm">
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            Product UPC{" "}
                            <span className="smallTxt">
                              (Universal Product Code)
                            </span>
                          </div>
                          <div className='flexCenter'>
                            <input
                              className="form-control"
                              type={"text"}
                              name="productUpc"
                              value={productForm.productUpc}
                              onChange={handleFormValue}
                              onBlur={handleInputBlur}
                              disabled={!isEditable}
                            />

                            <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="productUpc" />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            EAN{" "}
                            <span className="smallTxt">
                              (International Article Number)
                            </span>
                          </div>
                          <div className='flexCenter'>
                            <input
                              className={`form-control`}
                              type={"text"}
                              name="ean"
                              value={productForm.ean}
                              onChange={handleFormValue}
                              onBlur={handleInputBlur}
                              disabled={!isEditable}
                            />
                            <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="ean" />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            MPN{" "}
                            <span className="smallTxt">
                              (Manufacturer Part Number)
                            </span>
                          </div>
                          <div className='flexCenter'>
                            <input
                              className="form-control"
                              type={"text"}
                              name="mpn"
                              value={productForm.mpn}
                              onChange={handleFormValue}
                              onBlur={handleInputBlur}
                              disabled={!isEditable}
                            />
                            <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="mpn" />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            ISBN{" "}
                            <span className="smallTxt">
                              (International Standard Book Number)
                            </span>
                          </div>
                          <div className='flexCenter'>
                            <input
                              className={`form-control`}
                              type={"text"}
                              name="isbn"
                              value={productForm.isbn}
                              onChange={handleFormValue}
                              onBlur={handleInputBlur}
                              disabled={!isEditable}
                            />
                            <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="isbn" />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>
                            HSN{" "}
                            <span className="smallTxt">
                              (Harmonised System of Nomenclature)
                            </span>
                          </div>
                          <div className='flexCenter'>
                            <input
                              className={`form-control`}
                              type={"text"}
                              name="hsn"
                              value={productForm.hsn}
                              onChange={handleFormValue}
                              onBlur={handleInputBlur}
                              disabled={!isEditable}
                            />
                            <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="hsn" />
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      Miscellaneous{" "}
                      <i className="fa fa-chevron-down" aria-hidden="true"></i>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="row addressForm">
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>Selling Price ($)</div>
                          <input
                            className={`form-control sellingPrice`}
                            type={"number"}
                            name="sellingPrice"
                            value={productForm.sellingPrice}
                            onChange={handleFormValue}
                            onBlur={handleInputBlur}
                            min={0}
                            disabled={!isEditable}
                            onKeyDown={(evt) =>
                              ["e", "E", "+", "-"].includes(evt.key) &&
                              evt.preventDefault()
                            }
                          />
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>Cost Price ($)</div>
                          <input
                            className={`form-control costPrice`}
                            type={"number"}
                            min={0}
                            onKeyDown={(evt) =>
                              ["e", "E", "+", "-"].includes(evt.key) &&
                              evt.preventDefault()
                            }
                            name="costPrice"
                            value={productForm.costPrice}
                            onChange={handleFormValue}
                            disabled={!isEditable}
                            onBlur={handleInputBlur}
                          />
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>Condition</div>
                          <input
                            className={`form-control condition`}
                            type={"text"}
                            name="condition"
                            value={productForm.condition}
                            onChange={handleFormValue}
                            disabled={!isEditable}
                            onBlur={handleInputBlur}
                          />
                        </div>

                        <div className="col-lg-12 col-sm-12">
                          <div>Comments</div>
                          <input
                            className={`form-control`}
                            type={"text"}
                            name="comments"
                            value={productForm.comments}
                            onChange={handleFormValue}
                            disabled={!isEditable}
                            onBlur={handleInputBlur}
                          />
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      Others{" "}
                      <i className="fa fa-chevron-down" aria-hidden="true"></i>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="row addressForm">
                        <div className="col-lg-4 col-md-6 col-sm-12 mobMb-10">
                          <div className="row">
                            <div className="col-4">
                              <input
                                className={`form-control productSku`}
                                type={"text"}
                                name="option1"
                                value={productForm.option1}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                placeholder="Option 1"
                              />
                            </div>
                            <div className="col-8">
                              <input
                                className={`form-control productSku`}
                                type={"text"}
                                name="name1"
                                value={productForm.name1}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                placeholder="Option 1 Value"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mobMb-10">
                          <div className="row">
                            <div className="col-4">
                              <input
                                className={`form-control productSku`}
                                type={"text"}
                                name="option2"
                                value={productForm.option2}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                placeholder="Option 2"
                              />
                            </div>
                            <div className="col-8">
                              <input
                                className={`form-control productSku`}
                                type={"text"}
                                name="name2"
                                value={productForm.name2}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                placeholder="Option 2 Value"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mobMb-10">
                          <div className="row">
                            <div className="col-4">
                              <input
                                className={`form-control productSku`}
                                type={"text"}
                                name="option3"
                                value={productForm.option3}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                                placeholder="Option 3"
                              />
                            </div>
                            <div className="col-8">
                              <DatePicker
                                className="form-control itemExpiryDate"
                                showIcon
                                autoComplete="one-time-code"
                                dateFormat="MM-dd-yyyy"
                                selected={
                                  productForm?.name3
                                    ? new Date(productForm?.name3)
                                    : ""
                                }
                                name="name3"
                                onChange={(date) =>
                                  handleDateChange(date, "name3")
                                }
                                disabled={!isEditable}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      Marketplace SKUs{" "}
                      <i className="fa fa-chevron-down" aria-hidden="true"></i>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="row addressForm">
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>Amazon SKU</div>
                          <div className="generateSkuInputWrapper">
                            <div className='flexCenter'>
                              <input
                                className={`form-control marketplaceSku`}
                                type={"text"}
                                name="amazonSku"
                                value={productForm.amazonSku}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                              />
                              <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="amazonSku" />
                            </div>
                            <div className="generateBar">
                              {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && productForm.amazonSku && (
                                <button className="btn generateBar pr-0 pt-0 pb-0" onClick={() => handleBarCodeClick(productForm, 'amazonSku')}>Generate Barcode</button>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>eBay SKU</div>
                          <div className="generateSkuInputWrapper">
                            <div className='flexCenter'>
                              <input
                                className={`form-control marketplaceSku`}
                                type={"text"}
                                name="eBaySku"
                                value={productForm.eBaySku}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                              />
                              <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="eBaySku" />
                            </div>
                            <div className="generateBar">
                              {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && productForm.eBaySku && (
                                <button className="btn generateBar pr-0 pt-0 pb-0" onClick={() => handleBarCodeClick(productForm, 'eBaySku')}>Generate Barcode</button>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>Shopify SKU</div>
                          <div className="generateSkuInputWrapper">
                            <div className='flexCenter'>
                              <input
                                className={`form-control marketplaceSku`}
                                type={"text"}
                                name="shopifySku"
                                value={productForm.shopifySku}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                              />
                              <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="shopifySku" />
                            </div>
                            <div className="generateBar">
                              {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && productForm.shopifySku && (
                                <button className="btn generateBar pr-0 pt-0 pb-0" onClick={() => handleBarCodeClick(productForm, 'shopifySku')}>Generate Barcode</button>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>Etsy SKU</div>
                          <div className="generateSkuInputWrapper">
                            <div className='flexCenter'>
                              <input
                                className={`form-control marketplaceSku`}
                                type={"text"}
                                name="etsySku"
                                value={productForm.etsySku}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                              />
                              <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="etsySku" />
                            </div>
                            <div className="generateBar">
                              {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && productForm.etsySku && (
                                <button className="btn generateBar pr-0 pt-0 pb-0" onClick={() => handleBarCodeClick(productForm, 'etsySku')}>Generate Barcode</button>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>TikTok SKU</div>
                          <div className="generateSkuInputWrapper">
                            <div className='flexCenter'>
                              <input
                                className={`form-control marketplaceSku`}
                                type={"text"}
                                name="tiktokSku"
                                value={productForm.tiktokSku}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                              />
                              <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="tiktokSku" />
                            </div>
                            <div className="generateBar">
                              {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && productForm.tiktokSku && (
                                <button className="btn generateBar pr-0 pt-0 pb-0" onClick={() => handleBarCodeClick(productForm, 'tiktokSku')}>Generate Barcode</button>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                          <div>Walmart SKU</div>
                          <div className="generateSkuInputWrapper">
                            <div className='flexCenter'>
                              <input
                                className={`form-control walmartSku`}
                                type={"text"}
                                name="walmartSku"
                                value={productForm.walmartSku}
                                onChange={handleFormValue}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                              />
                              <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="walmartSku" />
                            </div>
                            <div className="generateBar">
                              {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && productForm.walmartSku && (
                                <button className="btn generateBar pr-0 pt-0 pb-0" onClick={() => handleBarCodeClick(productForm, 'walmartSku  ')}>Generate Barcode</button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* Marketplace listing drafts — only meaningful once the product has been
                    saved (we need an inventoryProductId to key drafts on). The section
                    renders nothing when productId is falsy, but we still gate on edit-mode
                    explicitly so the Add page stays focused on the inventory form.
                    The anchor id lets a post-create navigate scroll the user straight to it
                    via the focusMarketplaces flag handled in the effect below. */}
                {Number(id) > 0 && (
                  <div id="marketplace-drafts-section">
                    <MarketplaceDraftsSection product={productForm} />
                  </div>
                )}
              </div>
              {Number(id) > 0 && (
                <ProductImageSlider
                  productForm={productForm}
                  setProductForm={setProductForm}
                  isEditable={isEditable}
                  userDetails={userDetails}
                  productFormCopy={productFormCopy}
                  setProductFormCopy={setProductFormCopy}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <AlertDialogModal
        modalShow={showUnsavedDialog}
        handleCancelDeleteAlert={() => setShowUnsavedDialog(false)}
        modalClass={"modalDeleteWrapper"}
        messageText="Are you sure you want to cancel?"
        handleYesDeleteAlert={() => handleBack(true)}
        headingText={"ALERT"}
      />

      <BarCodeGeneratePopup
        showPopup={showBarCodeModal}
        hidePopup={setShowBarCodeModal}
        barCodeRecord={barCodeRecord}
      />

      <BarcodeScannerComponent
        setShowScanner={setShowScanner}
        showScanner={showScanner}
        handleScanSuccess={handleScanSuccess}
      />
    </main>
  );
};

ProductInventory.propTypes = {
  employeePermissions: PropTypes.array
}

export default ProductInventory;
